import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconCctvLine,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/educationSafety/img/1.avif';
import image2 from '@src/assets/images/solution/educationSafety/img/2.avif';
import image3 from '@src/assets/images/solution/educationSafety/img/3.avif';
import image4 from '@src/assets/images/solution/educationSafety/img/4.avif';

import customer1 from '@src/assets/images/solution/publicFire/img/customer1.avif';
import function1 from '@src/assets/images/solution/educationSafety/img/function1.avif';
import function2 from '@src/assets/images/solution/educationSafety/img/function2.avif';
import function3 from '@src/assets/images/solution/educationSafety/img/function3.avif';
import function4 from '@src/assets/images/solution/educationSafety/img/function4.avif';
import { educationSafety1, recommendationEdge, recommendationSwitch } from '@assets/images/solution/recommendation';
import recommendation from '../common/recommendation';

export default {
  type: '학교 안전 솔루션',

  banner: {
    title: '위험 행동을 실시간으로 감지해 학교 안전에 즉시 대응하세요',
    desc: 'AI 영상분석으로 학생의 폭력이나 낙상 징후를 실시간으로 감지하고 관리자에게 즉시 알림을 전송합니다',
  },

  recommend: {
    title: 'AI 카메라로 학생의 위험행동을 실시간 감지하고 관리자에게 즉시 알림을 전송합니다',
    desc: '교내 CCTV 또는 AI 전용 카메라가 위험행동을 감지하고, 온프레미스 서버에서 데이터를 분석해 이상 징후를 실시간 알림으로 전송합니다',
    labels: {
      desktop: [
        {
          img: educationSafety1,
          data: recommendation.ipCamera,
        },
        {
          img: recommendationEdge,
          data: recommendation.edgeRtls,
        },
        {
          img: recommendationSwitch,
          data: recommendation.switch,
        },
      ],
      mobile: [
        {
          data: recommendation.ipCamera,
        },
        {
          data: recommendation.edgeAi,
        },
        {
          data: recommendation.switch,
        },
      ],
    },
  },
  summary: {
    title: '위험 상황을 실시간으로 감지하고 즉시 대응하세요.',
    desc: 'AI 기반 포즈 인식 기술을 통해 학생 간의 폭력, 낙상, 의식 상실, 돌발 행동 등을 실시간으로 감지하고 즉시 경고합니다. 복도, 계단, 교실, 실험실 등 다양한 공간에서 사고를 조기에 인지하고 빠르게 대응할 수 있도록 도와줍니다.',
    function: {
      card: [
        {
          image: function1,
          title: '폭력 행위(싸움) 자동 감지',
          desc: '두 사람 간의 물리적 충돌, 주먹 휘두름, 밀침과 같은 폭력적인 행동을 포즈 움직임으로 감지합니다. 싸움 징후가 나타나면 실시간으로 관리자에게 경고해 교내 폭력 사고를 조기에 차단할 수 있습니다.',
        },
        {
          image: function2,
          title: '복도·계단 등 낙상 사고 감지 및 경보',
          desc: '계단이나 복도에서 학생이 넘어지는 동작을 포즈 자세 변화로 인식합니다. 낙상이 감지되면 즉시 알림을 전송해 빠르게 응급 대응할 수 있도록 합니다.',
        },
        {
          image: function3,
          title: '바닥에 장시간 누움/의식 없음 상태 감지',
          desc: '학생이 넘어진 이후에도 오랫동안 움직임이 없거나 비정상적으로 누워 있는 상태를 감지합니다. 의식 불명이나 발작 등 응급 상황으로 판단하고 경고를 발송합니다.',
        },
        {
          image: function4,
          title: '비정상 행동(질주, 돌발 행동) 자동 감지',
          desc: '복도나 계단에서 갑작스럽게 뛰거나 방향 없이 질주하는 행동을 감지합니다. 충돌 위험이 있는 돌발 행동을 조기에 파악해 사고를 미연에 방지할 수 있습니다.',
        },
      ],
    },
  },

  numOfCard: {
    title: 'AI 기술로 학교 안전관리 운영 효율을 극대화하세요',
    desc: '실시간 감지기능으로 학교 내 이상행동과 위험 상황에 신속하고 효과적으로 대응합니다.',
    card: [
      {
        tag: '98%',
        title: '이상행동 감지 정확도',
        desc: '정확한 AI 분석으로 학교 내 이상행동 및 위험 상황을 즉시 파악하여 빠르게 대응할 수 있습니다.',
      },
      {
        tag: '95%',
        title: '운영 인력 절감 효과',
        desc: '자동화된 AI 시스템으로 운영 인력을 최소화하며 학교 안전 관리의 효율성을 높입니다.',
      },
      {
        tag: '100%',
        title: '개인정보 보호 준수율',
        desc: '개인정보 보호를 최우선으로 하여 영상을 저장하지 않고, 사건 발생 시에만 짧은 영상 기록으로 철저히 관리합니다.',
      },
    ],
  },

  func: [
    {
      theme: '첨단 AI 기능으로 학교 내 위험을 정확히 감지하고 대응하세요.',
      title: '상황별 대응 내역 자동 기록',
      desc: '강한 움직임, 이상 행동 및 공격성 행동을 포즈 추정 AI 기술로 정확히 분석하여 위험을 자동으로 감지합니다. 이를 통해 신속하고 정확하게 위험 상황에 대응하고 관리할 수 있습니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '실시간 현황 파악',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: '5단계 위험 수준별 즉각적인 알림 제공',
      desc: 'AI가 분석한 위험 상황을 5단계로 구분하여 즉각적으로 관련 관리자에게 알림을 전송합니다. 위험의 심각성에 따라 단계별로 효율적인 대응책을 마련하고 신속히 처리할 수 있습니다.',
      sub2: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub1: '빠른 데이터 연동',
      icon2: IconTvocGray,
      image: image2,
    },
    {
      title: '온프레미스 방식의 독립적 운영 가능',
      desc: '학교 내 자체 서버에 솔루션을 구축하여 외부 의존도를 줄이고, 자체적으로 데이터를 관리하고 운영할 수 있습니다. 이를 통해 즉각적인 문제 대응과 지속적인 시스템 개선이 가능합니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: '개인정보 보호와 이벤트 중심 영상 기록',
      desc: '실시간 분석 중 위험 이벤트가 감지될 때만 짧은 영상을 기록하여 개인정보 보호를 엄격히 준수합니다. 영상 데이터를 저장하지 않아 학교 내 CCTV 운영의 부담을 최소화할 수 있습니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image4,
    },
  ],

  subfunc: {
    title: '기능 요약',
    desc: '작업자의 안전을 보장하는 것은 효율성을 높이고 사고로 인한 손실을 줄입니다. 오브로는 건설 현장 작업자의 안전을 지키기 위해서 최적의 기능들을 구성하였습니다. 작업자가 위험 지역에 다가거나 사고가 발생했을 때, 또는 중장비가 가진 잠재적 위험상황을 포함하여 발생할 수 있는 안전사고에 적절히 대응하도록 시스템을 구축하였습니다.',

    data: [
      {
        icon: IconWarning, // 폭력 행동 → 위험 경고 의미
        title: '폭력 행동 실시간 감지',
        desc: '학생 간 충돌이나 폭력 동작을 AI가 실시간 인식해 즉시 관리자에게 알림을 전송합니다.',
      },
      {
        icon: IconWarning, // 낙상 사고 → 응급 알림
        title: '낙상 사고 자동 감지',
        desc: '복도나 계단 등에서의 낙상 자세를 즉시 인식해 응급 대응을 유도합니다.',
      },
      {
        icon: IconAnalytics, // 움직임 없음 감지 → 상태 분석
        title: '장시간 움직임 없음 감지',
        desc: '학생이 쓰러진 뒤 장시간 움직이지 않으면 비정상 상태로 판단해 경고를 발송합니다.',
      },
      {
        icon: IconAnalytics, // 돌발 행동 → 예측 불가/위험 행동 감지
        title: '돌발 행동 및 질주 탐지',
        desc: '급작스러운 질주나 예측 불가한 돌발 행동을 인식해 충돌 사고를 사전에 차단합니다.',
      },
      {
        icon: IconLayers, // 단계별 대응 → 다중 등급 처리
        title: '위험 등급 분류 및 단계별 대응',
        desc: '인식된 위험을 5단계로 분류해 심각도에 따라 맞춤형 대응 경고를 제공합니다.',
      },
      {
        icon: IconSearch, // 영상 클립 저장 → 개인정보 보호/필요 시만 기록
        title: '영상 클립만 저장하는 개인정보 보호',
        desc: '사고 감지 시점의 짧은 영상만 저장하고 자동 삭제돼 영상 보안과 사생활 보호를 강화합니다.',
      },
      {
        icon: IconCctvLine, // 기존 CCTV 연동 → 호환성
        title: '기존 CCTV 연동 호환성',
        desc: '기존 학교 CCTV 인프라와 즉시 연동되어 추가 설치 없이 도입 가능합니다.',
      },
      {
        icon: IconSearch, // 온프레미스 운영 → 독립 서버 처리
        title: '온프레미스 기반 독립 운영',
        desc: '학교 내부 서버에서 운영돼 외부 전송 없이 안정적인 보안 체계를 유지합니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'workerPackage',
    },
    {
      tag: 'assetPackage',
    },
  ],

  contents: [
    {
      data: 'constructionAsset',
    },
    {
      data: 'constructionEquipment',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogMedical',
    },
  ],
};
